import "./SitesGridArchitecture.module.css";
import Header from "@/reusable_sections/Header";
import HeroBanner from "./sections/HeroBanner";
import SitesGrid from "./sections/SitesGrid";
import CallToAction from "./sections/CallToAction";
import SiteFilterGrid from "./sections/SiteFilterGrid";
import Footer from "@/reusable_sections/Footer";
export default function SitesGridArchitecturePage() {
  return <div>
      <Header />
      <HeroBanner />
      <SiteFilterGrid />
      <SitesGrid />
      <CallToAction />
      <Footer />
    </div>;
}